/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import * as styles from './style';


interface ISearchBarProps {
    placeholder: string;
    handleSubmit: (value: string, fieldName: string) => void;
    fieldName: string;
}

export const SearchBar: React.FC<ISearchBarProps> = (props: ISearchBarProps) => {
    const { placeholder, fieldName, handleSubmit } = props;

    const [inputValue, handleChange] = React.useState("");

    const handleKeyPress = (e: any) => {
        //Enter Click
        if (e.key === "Enter") {
            handleSubmit(inputValue, fieldName);
        }
    }

    return (
        <div css={styles.searchBar}>
            <input type="text" value={inputValue} name={fieldName} onChange={(e) => handleChange(e.target.value)} placeholder={placeholder} css={styles.searchInput} onKeyPress={handleKeyPress}>
            </input>
            <img onClick={() => handleSubmit(inputValue, fieldName)} css={styles.searchIcon} src="/images/search-pink.svg" />
        </div >
    )
}